import TimelineActivityAppointment from "~/components/drawers/timeline/activity_appointment";
import TimelineActivityAppointmentSent from "~/components/drawers/timeline/activity_appointment_sent";
import TimelineActivityBucket from "~/components/drawers/timeline/activity_bucket";
import TimelineActivityCampaignSubscription from "~/components/drawers/timeline/activity_campaign_subscription";
import TimelineActivityCandidateAdded from "~/components/drawers/timeline/activity_candidate_added";
import TimelineActivityCandidateApplied from "~/components/drawers/timeline/activity_candidate_applied";
import TimelineActivityCandidateMoved from "~/components/drawers/timeline/activity_candidate_moved";
import TimelineActivityCandidateRemoved from "~/components/drawers/timeline/activity_candidate_removed";
import TimelineActivityDeleteJob from "~/components/drawers/timeline/activity_delete_job";
import TimelineActivityDocument from "~/components/drawers/timeline/activity_document";
import TimelineActivityEmail from "~/components/drawers/timeline/activity_email";
import TimelineActivityEmailSent from "~/components/drawers/timeline/activity_email_sent";
import TimelineActivityJobMatch from "~/components/drawers/timeline/activity_job_match";
import TimelineActivityLeadUpdate from "~/components/drawers/timeline/activity_lead_update";
import TimelineActivityMerge from "~/components/drawers/timeline/activity_merge";
import TimelineActivityMessageScheduled from "~/components/drawers/timeline/activity_message_scheduled";
import TimelineActivityNote from "~/components/drawers/timeline/activity_note";
import TimelineActivityOwnerChange from "~/components/drawers/timeline/activity_owner_change";
import TimelineActivityPhoneCall from "~/components/drawers/timeline/activity_phone_call";
import TimelineActivityReassign from "~/components/drawers/timeline/activity_reassign";
import TimelineActivityReferrerUpdate from "~/components/drawers/timeline/activity_referrer_update";
import TimelineActivityReleasePhoneNumber from "~/components/drawers/timeline/activity_release_phone_number";
import TimelineActivityResume from "~/components/drawers/timeline/activity_resume";
import TimelineActivityRetention from "~/components/drawers/timeline/activity_retention";
import TimelineActivitySmsConversation from "~/components/drawers/timeline/activity_sms_conversation";
import TimelineActivityStatus from "~/components/drawers/timeline/activity_status";
import TimelineActivityTask from "~/components/drawers/timeline/activity_task";
import TimelineActivityTextMessage from "~/components/drawers/timeline/activity_text_message";
import CustomFieldsActivity from "~/features/customFields/CustomFieldsActivity";

const ActivityComponentMap = {
  "lead.custom_fields_update": { Component: CustomFieldsActivity },
  "lead.create_task": {
    Component: TimelineActivityTask,
    props: { color: "text-green" },
  },
  "lead.destroy_task": {
    Component: TimelineActivityTask,
    props: { color: "text-red" },
  },
  "lead.update_task": {
    Component: TimelineActivityTask,
    props: { color: "text-green" },
  },
  "lead.status": { Component: TimelineActivityStatus },
  "lead.bucket": { Component: TimelineActivityBucket },
  "lead.note": { Component: TimelineActivityNote },
  "lead.merge": { Component: TimelineActivityMerge },
  "lead.reassign": { Component: TimelineActivityReassign },
  "lead.phone_call": { Component: TimelineActivityPhoneCall },
  "lead.text_message": { Component: TimelineActivityTextMessage },
  "lead.sms_conversation": { Component: TimelineActivitySmsConversation },
  "lead.appointment_sent": { Component: TimelineActivityAppointmentSent },
  "lead.appointment_saved": {
    Component: TimelineActivityAppointmentSent,
    props: { title: "Appointment Saved" },
  },
  "lead.appointment": { Component: TimelineActivityAppointment },
  "lead.retention": { Component: TimelineActivityRetention },
  "lead.email": { Component: TimelineActivityEmail },
  "lead.email_sent": {
    Component: TimelineActivityEmailSent,
    props: { showReplyButtons: true },
  },
  "lead.email_scheduled": {
    Component: TimelineActivityMessageScheduled,
    props: { messageType: "email", editable: true, title: "Scheduled Email" },
  },
  "lead.email_schedule_updated": {
    Component: TimelineActivityMessageScheduled,
    props: {
      messageType: "email",
      editable: true,
      title: "Updated Scheduled Email",
    },
  },
  "lead.email_schedule_canceled": {
    Component: TimelineActivityMessageScheduled,
    props: {
      messageType: "email",
      editable: false,
      title: "Scheduled Email Canceled",
      deletable: false,
    },
  },
  "lead.campaign_email_sent": {
    Component: TimelineActivityEmailSent,
    props: { title: "Campaign Email Sent", showReplyButtons: true },
  },
  "lead.forwarded_email": {
    Component: TimelineActivityEmailSent,
    props: {
      title: "Forward Inbound Email",
      color: "text-blue-forwarded",
      showReplyButtons: true,
    },
  },
  "lead.forwarded_email_reply": {
    Component: TimelineActivityEmailSent,
    props: {
      title: "Forward Email Reply",
      color: "text-blue-forwarded-reply",
      showReplyButtons: true,
    },
  },
  "lead.bcc_email": {
    Component: TimelineActivityEmailSent,
    props: {
      title: "Email logged via BCC",
      color: "text-blue-bcc",
      showReplyButtons: true,
    },
  },
  "lead.campaign_subscription": {
    Component: TimelineActivityCampaignSubscription,
  },
  "lead.campaign_subscription_delete": {
    Component: TimelineActivityCampaignSubscription,
  },
  "lead.campaign_subscription.paused_due_to_text_reply": {
    Component: TimelineActivityCampaignSubscription,
  },
  "lead.campaign_subscription.paused_due_to_email_reply": {
    Component: TimelineActivityCampaignSubscription,
  },
  "lead.release_phone_number": {
    Component: TimelineActivityReleasePhoneNumber,
  },
  "lead.owner_assigned": { Component: TimelineActivityOwnerChange },
  "lead.owner_changed": { Component: TimelineActivityOwnerChange },
  "lead.owner_removed": { Component: TimelineActivityOwnerChange },
  "lead.update": { Component: TimelineActivityLeadUpdate },
  "lead.zapier_created": {
    Component: TimelineActivityLeadUpdate,
    props: {
      title: (o) =>
        `${o.props.activity.parameters.name} was created via Zapier`,
      icon: "bolt",
      prefix: "fas",
    },
  },
  "lead.zapier_updated": {
    Component: TimelineActivityLeadUpdate,
    props: {
      title: (o) =>
        `${o.props.activity.parameters.name} was updated via Zapier`,
      icon: "bolt",
      prefix: "fas",
    },
  },
  "lead.referrer_changed": { Component: TimelineActivityReferrerUpdate },
  "lead.create_resume": {
    Component: TimelineActivityResume,
    props: { resume_status: "Resume Uploaded" },
  },
  "lead.update_resume": {
    Component: TimelineActivityResume,
    props: { resume_status: "Resume Updated" },
  },
  "lead.delete_resume": {
    Component: TimelineActivityResume,
    props: { resume_status: "Resume Deleted" },
  },
  "lead.create_document": {
    Component: TimelineActivityDocument,
    props: { document_status: "Document Uploaded" },
  },
  "lead.update_document": {
    Component: TimelineActivityDocument,
    props: { document_status: "Document Updated" },
  },
  "lead.delete_document": {
    Component: TimelineActivityDocument,
    props: { document_status: "Document Deleted" },
  },
  "lead.text_message_scheduled": {
    Component: TimelineActivityMessageScheduled,
    props: {
      messageType: "sms_message",
      icon: "comment",
      color: "text-yellow",
      title: "Scheduled Text",
    },
  },
  "lead.text_message_schedule_updated": {
    Component: TimelineActivityMessageScheduled,
    props: {
      messageType: "sms_message",
      icon: "comment",
      color: "text-yellow",
      title: "Updated Scheduled Text",
    },
  },
  "lead.text_message_schedule_canceled": {
    Component: TimelineActivityMessageScheduled,
    props: {
      messageType: "sms_message",
      icon: "comment",
      color: "text-yellow",
      editable: false,
      title: "Scheduled Text Canceled",
      deletable: false,
    },
  },
  "lead.job_match": { Component: TimelineActivityJobMatch },
  "lead.delete_job": { Component: TimelineActivityDeleteJob },
  "lead.candidate_applied": { Component: TimelineActivityCandidateApplied },
  "lead.candidate_added": { Component: TimelineActivityCandidateAdded },
  "lead.candidate_moved": { Component: TimelineActivityCandidateMoved },
  "lead.candidate_removed": { Component: TimelineActivityCandidateRemoved },
};

export default ActivityComponentMap;
